export default [
    { name: 'DRE', url: '/dre', icon: 'fas fa-dollar-sign', rule: 'DRE' },
    { name: 'DFC/Contas bancárias', url: '/fluxo-de-caixa', icon: 'fas fa-chart-line', rule: 'FluxoDeCaixa' },
    { name: 'Indice de Gestão', url: '/indice-de-gestao', icon: 'fas fa-chart-pie', rule: 'IndiceDeGestao' },
    { name: 'Cluster', url: '/cluster', icon: 'fas fa-layer-group', rule: 'Cluster' },
    { name: 'De - Para', url: '/de-para', icon: 'fas fa-cog', rule: 'DePara' },
    { name: 'Upload', url: '/upload', icon: 'fas el-icon-upload', rule: 'Arquivo' },
    { name: 'Relatórios', url: '/relatorio', icon: 'far fa-file', rule: 'Relatorio', onlyPremium: true },
    { name: 'Sincronização', url: '/sincronizacao', icon: 'fa fa-sync', rule: 'Sincronizacao' },
    { name: 'Empresas', url: '/empresas', icon: 'fa fa-building', rule: 'Empresa' },
    { name: 'Usuários', url: '/usuarios', icon: 'fas fa-user', rule: 'usuarios' },
    { name: 'Webservice', url: '/webservice', icon: 'fas fa-plug', rule: 'Webservice' }
]
